import { render, staticRenderFns } from "./company-list-waitapprove.vue?vue&type=template&id=3ce97e92&scoped=true&"
import script from "./company-list-waitapprove.vue?vue&type=script&lang=js&"
export * from "./company-list-waitapprove.vue?vue&type=script&lang=js&"
import style0 from "./company-list-waitapprove.vue?vue&type=style&index=0&id=3ce97e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce97e92",
  null
  
)

export default component.exports